// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"211":"b8615da9","947":"2da77a98"}[chunkId] + ".chunk.js";
};